import React, { Dispatch, SetStateAction, useState } from 'react'
import styled from 'styled-components'
import { DateRangePicker } from '../../../../../../generic/ui/DatePicker'
import ReportSelector from '../../../../../../generic/ui/Selectors/ReportSelector'
import { AccentButton } from '../../../../../../generic/ui/Button/AccentButton'
import ImageComponentHead from '../../../../../../generic/imageComponents/ImageComponentHead'
import Image from '../../../../../../generic/assets/cogsPNG.png'
import {
  FormShell,
  FormGrid,
  FormField,
  FormFooter,
} from '../../../../../../generic/ui/FormLayout'
import { IReportListItem } from '../../../../../../modules/API/Reports/models/reportList'
import { IProcedures } from '../../../../../../../store/reducers/procedures'
import { resolvePartialEnd, toRangeSelected } from '../helpers/dateRange'

type Props = {
  setStartDate: Dispatch<SetStateAction<string>>
  setEndDate: Dispatch<SetStateAction<string>>
  reportList: IReportListItem[] | null
  handleSave: (RepID: number) => void
  handleDate: (e: [Date | null, Date | null]) => void
  setDefaultDate: IProcedures['Q4']['date']
  cashReport: IReportListItem | null
  handleDispatchReport: (item: IReportListItem) => void
  closeFunc?: () => void
}

/** Фильтр процедур Q2/Q4: диапазон дат + отчёт. */
const ReportFilterForm = ({
  setStartDate,
  setEndDate,
  reportList,
  handleSave,
  handleDate,
  setDefaultDate,
  cashReport,
  handleDispatchReport,
}: Props) => {
  const [selectedReport, setSelectedReport] = useState<IReportListItem | null>(cashReport)

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    handleDate(dates)
    const partialEnd = resolvePartialEnd(dates)
    if (partialEnd) setEndDate(partialEnd)
  }

  const handleSelectReport = (report: IReportListItem | null) => {
    setSelectedReport(report)
    if (report) handleDispatchReport(report)
  }

  return (
    <TallFormShell>
      <ImgContainer>
        <ImageComponentHead img={Image} large />
      </ImgContainer>
      <FormGrid>
        <FormField label='בחר תאריכים' fullWidth>
          <DateRangePicker
            selected={toRangeSelected(setDefaultDate)}
            setDate={setStartDate}
            setDateEnd={setEndDate}
            onChange={handleDateChange}
          />
        </FormField>

        <FormField label='בחר דוח' required fullWidth>
          <ReportSelector
            reports={reportList ?? []}
            value={selectedReport}
            onSelect={handleSelectReport}
          />
        </FormField>
      </FormGrid>
      <Footer>
        <AccentButton
          type='button'
          disabled={!selectedReport}
          onClick={() => selectedReport && handleSave(selectedReport.RepID)}
        >
          {'הצג'}
        </AccentButton>
      </Footer>
    </TallFormShell>
  )
}

export default ReportFilterForm

/* Полей всего два — без минимальной высоты выпадающий список отчётов упирается в край модалки. */
const TallFormShell = styled(FormShell)`
  min-height: 24rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    min-height: 22rem;
  }
`

const ImgContainer = styled.div`
  height: 9rem;
  display: flex;
  justify-content: center;

  img {
    min-width: 0;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`

/** Прижат к низу формы, даже когда полей мало; при прокрутке остаётся sticky. */
const Footer = styled(FormFooter)`
  margin-top: auto;
`
